import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const formatCurrency = (value) => {
  if (value >= 1000000) return `$${(value / 1000000)?.toFixed(1)}M`;
  if (value >= 1000) return `$${(value / 1000)?.toFixed(0)}K`;
  return `$${value}`;
};

const PipelineForecastChart = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="flex items-center justify-center h-48 text-muted-foreground text-sm">
        No forecast data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={240}>
      <AreaChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
        <defs>
          <linearGradient id="forecastGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#F39C12" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#F39C12" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" />
        <XAxis dataKey="month" tick={{ fontSize: 11 }} />
        <YAxis tickFormatter={formatCurrency} tick={{ fontSize: 11 }} />
        <Tooltip formatter={(value) => [formatCurrency(value), 'Weighted Pipeline']} />
        <Area type="monotone" dataKey="value" stroke="#F39C12" strokeWidth={2} fill="url(#forecastGradient)" />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default PipelineForecastChart;
